import { style, media } from 'typestyle'
import { important } from 'csx'
export const pr16mdi = style(media({ maxWidth: 768 }, { paddingRight: important('16px') }))
